$easyreels_user_recording $mol_view
	recording null
	sub <= content /$mol_view
		<= Row $mol_row
			sub /
				<= Status $easyreels_labeler_name
					title @ \Status
					value <= status_text \
				<= Size $easyreels_labeler_name
					title @ \Size
					value <= size_text \
				<= Created $easyreels_labeler_moment
					title @ \Created
					value <= created_text \
		<= Failure $mol_paragraph
			title <= failure_text \
		<= Failure_detail $mol_paragraph
			title <= failure_detail \
		<= Segments $mol_list
			rows <= segment_links /$mol_view
	Segment_link* $mol_link
		uri <= segment_uri* \
		file_name <= segment_file* \
		title <= segment_title* \
